import { render } from "./Donate.vue?vue&type=template&id=047da9ee&scoped=true"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"

import "./Donate.vue?vue&type=style&index=0&id=047da9ee&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-047da9ee"

export default script